"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = require("prop-types");

var index_1 = __importDefault(require("../Checkbox/index"));

require("./index.css");

var CheckboxGroup = function (_a) {
  var name = _a.name,
      options = _a.options,
      label = _a.label,
      direction = _a.direction,
      className = _a.className,
      onChange = _a.onChange;
  var directionVal = ['column', 'row'].indexOf(direction) >= 0 ? direction : 'column';
  var containerClass = "ui-checkbox-group direction-" + directionVal;

  if (className) {
    containerClass += " " + className;
  }

  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [label && (0, jsx_runtime_1.jsx)("div", __assign({
      className: "ui-checkbox-group-label",
      "data-testid": "checkbox-group-label-" + name
    }, {
      children: label
    }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
      className: containerClass,
      "data-testid": "radio-group-" + name
    }, {
      children: options.map(function (option) {
        var optId = option.label.replace(/\s+/g, '-').toLowerCase();
        return (0, jsx_runtime_1.jsx)(index_1.default, {
          name: name,
          id: option.value,
          label: option.label,
          value: option.value,
          "data-testid": "checkbox-" + optId,
          selected: option.selected,
          onChange: function () {
            return onChange(option);
          }
        }, option.key || option.label);
      })
    }), void 0)]
  }, void 0);
};

CheckboxGroup.propTypes = {
  options: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    name: prop_types_1.string,
    value: prop_types_1.string,
    selected: prop_types_1.bool
  })),
  label: prop_types_1.string,
  direction: prop_types_1.string,
  onChange: prop_types_1.func,
  name: prop_types_1.string.isRequired,
  className: prop_types_1.string
};
CheckboxGroup.defaultProps = {
  label: '',
  direction: 'column',
  onChange: function () {},
  options: [],
  className: ''
};
exports.default = CheckboxGroup;